<mat-spinner class="spinner" diameter="30" *ngIf="loading"></mat-spinner>

<div tabindex="0" class="video-wrap" #wrapperDiv [class.youtube-player]="!!youtubeVideoId">
  <iframe
    #iframeVideo
    [src]="heroVideo"
    *ngIf="!youtubeVideoId"
    allow="autoplay"
    title="Welcome video"
    allowfullscreen
    frameborder="0"
  ></iframe>
</div>
<div class="skip-popup-wrap">
  <a (click)="closePopup()" tabindex="0" (accessibleClick)="closePopup()">
    {{ 'OnBoardingPopup:Skip' | translate }}
  </a>
</div>
